import {
    ADDED,
    ALLCOMPLETED,
    CLEARCOMPLETED,
    COLORSELECTED,
    DELETED,
    EDIT,
    LOADED,
    TOGGLED
} from "./actionTypes";

export const loaded = (todos) => {
    return {
        type: LOADED,
        payload: todos,
    };
};

export const added = (todoText) => {
    return {
        type: ADDED,
        payload: todoText,
    };
};

export const toggled = (todoId) => {
    return {
        type: TOGGLED,
        payload: todoId,
    };
};

export const colorSelected = (todoId, color) => {
    return {
        type: COLORSELECTED,
        payload: {
            todoId,
            color,
        },
    };
};

export const deleted = (todoId) => {
    return {
        type: DELETED,
        payload: todoId,
    };
};
export const edit = (id, text) => {
    return {
        type: EDIT,
        payload: { id, text },
    };
};

export const allCompleted = (todos) => {
    return {
        type: ALLCOMPLETED,
        payload: todos
    };
};

export const clearCompleted = () => {
    return {
        type: CLEARCOMPLETED,
    };
};
